import React, { useEffect, useRef } from "react";
import Projections from "@/components/film/Projections";
import { Navigation, Thumbs, FreeMode } from "swiper/modules";
import * as Text from "@/components/text";
import { ArrowRightIcon, ArrowLeftIcon } from "@heroicons/react/outline";

import { Swiper, SwiperSlide } from "swiper/react";
import useWindowSize from "@/hooks/useWindowSize";

import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import breakpoints from "@/constants/breakpoinst";
import { getStrapiImage } from "@/utils/strapiFunctions";

export default function EventsSlider({ events, venueName = "" }) {
  const beforeRef = useRef(null);
  const afterRef = useRef(null);
  const windowSize = useWindowSize();

  const [s, setS] = React.useState(null);

  useEffect(() => {
    if (s?.params) {
      s.params.navigation.prevEl = beforeRef.current;
      s.params.navigation.nextEl = afterRef.current;
      s.params.navigation.hiddenClass = "hidden";
      s.params.navigation.disabledClass = "text-neutral-50 border-neutral-50";
      s.params.navigation.enabled = events.length > 2;
      s.navigation.init();
      s.navigation.update();
    }
  }, [events]);

  return (
    <>
      {events.length ? (
        <div className="amb-container grid-cols-6 gap-16 border-b py-5 lg:grid">
          <div className="relative col-span-1 mb-3">
            <Text.Title
              fontWeight="bold"
              as="p"
              className="text-right normal-case"
              size="md"
            >
              {venueName}
            </Text.Title>
            {events.length > 2 ? (
              <div className="bottom-0 right-0 my-3 hidden md:block lg:absolute lg:my-0">
                <button
                  ref={beforeRef}
                  className="before-arrow  border-neutral-900/36 border p-2"
                >
                  <ArrowLeftIcon className="z-30 h-5 w-5" />
                </button>
                <button
                  ref={afterRef}
                  className="after-arrow border-neutral-900/36 border p-2"
                >
                  <ArrowRightIcon className="z-30 h-5 w-5" />
                </button>
              </div>
            ) : null}
          </div>
          <div className="col-span-5 inline  h-auto ">
            <Swiper
              className="flex w-full gap-2 align-middle "
              slidesPerView={windowSize.width < breakpoints.lg ? 1.2 : 2.1}
              spaceBetween={16}
              observer={true}
              threshold={10}
              modules={[Thumbs, Navigation, FreeMode]}
              freeMode={windowSize.width < breakpoints.lg}
              onInit={(swiper) => {
                swiper.params.navigation.prevEl = beforeRef.current;
                swiper.params.navigation.nextEl = afterRef.current;
                swiper.params.navigation.hiddenClass = "hidden";
                swiper.params.navigation.disabledClass =
                  "text-neutral-50 border-neutral-50";
                (swiper.params.navigation.enabled = events.length > 2),
                  swiper.navigation.init();
                swiper.navigation.update();
                setS(swiper);
              }}
            >
              {events.length > 0
                ? events.map((event, i) => (
                    <SwiperSlide key={event.id}>
                      <Projections
                        fullDate={false}
                        label={event.attributes.event_type || "Proyección"}
                        movie_title={
                          event.attributes?.event_name ||
                          event.attributes?.title
                        }
                        displayDate={
                          event?.attributes?.live_screenings
                            ? event?.attributes?.live_screenings[0]
                                ?.display_hour + " hrs"
                            : null
                        }
                        showTitle={true}
                        showImage={false}
                        view_more={
                          event.attributes?.live_screenings
                            ? `/catalogo/${event.attributes?.films?.data[0]?.attributes.filmSlug}`
                            : `/calendario/${event.id}`
                        }
                        movie_link={
                          event.attributes?.live_screenings
                            ? ""
                            : `/calendario/${event.id}`
                        }
                        movie={event.attributes.films.data[0]}
                        image={
                          getStrapiImage(event.attributes?.event_image, "medium") ||
                          getStrapiImage(
                            event.attributes?.films?.data[0]?.attributes
                              ?.film_cover_image,
                            "small"
                          )
                        }
                        film_projections={{
                          maps_url:
                            event.attributes?.sede?.data?.attributes
                              ?.venue_map_url,
                          type: "onSite",
                          from_date: event.attributes.date_time,
                          to_date: event.attributes.date_time,
                          cost: event?.attributes.event_admission_fee,
                          venue:
                            event?.attributes?.sede?.data?.attributes?.name ||
                            "",
                          city:
                            event?.attributes?.sede?.data?.attributes?.states ||
                            "",
                        }}
                      />
                    </SwiperSlide>
                  ))
                : null}
            </Swiper>
          </div>
        </div>
      ) : null}
    </>
  );
}
